"use strict";

var PropTypes = require("prop-types");

var classNames = require("classnames");
var LoggerInstance = require("js-logger").get("SimpleDropdownFromWizard");

class SimpleDropdownFromWizard extends React.Component {
	constructor(props) {
		super(props);

		var config = props.config || {};
		var configKey = props.configKey;
		var availableValues = config[configKey] || [];
		var wizard;
		var currentWizardValues;

		// If we are on the client side
		if (typeof (window) !== "undefined") {
			var wizard = props.wizard;
			var wizardValues = wizard[props.wizardValuesKey];
			if (wizard) {
				currentWizardValues = wizardValues || [];
			}

			if (!config[configKey] && wizardValues) {
				//This means we do not have the config set up yet.
				config = {};
				config[configKey] = wizardValues.map(value => {
					return {
						value,
						description: wizard[`${value}_Description`],
						useDefaultDescription: true
					};
				});
			}

			availableValues = config[configKey] ? config[configKey].slice(0) : []; // clone the array to avoid reference
		}

		if (currentWizardValues) {
			var availableValue;
			for (var index = availableValues.length - 1; index >= 0; --index) {
				availableValue = availableValues[index];
				var allowedIndex = currentWizardValues.indexOf(availableValue.value);
				if (allowedIndex === -1) {
					// AvailableValue is not allowed
					availableValues.splice(index, 1);
				} else if (availableValue.useDefaultDescription) {
					// AvailableValue should use default description
					availableValue.description = wizard[`${availableValue.value}_Description`];
				}
			}
		}

		this.state = {
			selectedValue: props.initialValue || "",
			availableValues
		};
	}

	handleValueSelected(event) {
		if (!event || !event.currentTarget) {
			return;
		}

		var selectedValue = event.currentTarget.value;
		this.setState({ selectedValue });

		if (typeof this.props.onChange === "function") {
			this.props.onChange(event);
		}
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		if (nextProps.initialValue !== prevState.selectedValue) {
			return {
				selectedValue: nextProps.initialValue
			};
		}

		return null;
	}

	componentDidMount() {
		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit wwwroot\js\designer\ExposedComponents.jsx
			parent.window.ComponentActions.childComponentLoaded(this.props.thisArg || this);
		}
	}

	componentWillUnmount() {
		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit wwwroot\js\designer\ExposedComponents.jsx
			parent.window.ComponentActions.childComponentUnloaded(this.props.thisArg || this);
		}
	}

	render() {
		var availableValues = this.state.availableValues;

		return (
			<div
				data-react-component-name={this.props.reactComponentName}
				data-component-id={!this.props.isCustomTheme ? this.props.dataComponentId : undefined}
				data-nested-id={this.props.dataNestedId}
				data-repeated-id={this.props.dataRepeatedId}
				data-theme={+this.props.theme ? this.props.theme : undefined}
				data-custom={this.props.isCustomTheme || null}
				data-child-of={this.props.dataChildOf}
				data-react-component-category={this.props.reactComponentCategory}
			>
				<select
					className={classNames("form-control", this.props.selectClassName)}
					style={this.props.isDesignMode ? {"pointerEvents": "none"} : undefined}
					data-override-classes={this.props.childClass}
					disabled={this.props.disabled || (!this.props.isDesignMode && (!availableValues || !availableValues.length))}
					name={this.props.selectNameAttribute}
					onChange={this.handleValueSelected.bind(this)}
					data-required={this.props.dataRequired}
					required={this.props.required || this.props.dataRequired}
					value={this.state.selectedValue}
				>
					{(!this.props.hideEmptyOption) &&
						<option value=""></option>
					}
					{availableValues && availableValues.map((availableValue) => {
						return (
							<option className={this.props.optionsClassName} key={availableValue.value} value={availableValue.value}>
								{availableValue.description}
							</option>
						);
					})}
				</select>
			</div>
		);
	}
}

SimpleDropdownFromWizard.defaultProps = {
	hideEmptyOptions: false
};

SimpleDropdownFromWizard.propTypes = {
	hideEmptyOption: PropTypes.bool,
	isDesignMode: PropTypes.bool,
	dataRequired: PropTypes.bool,
	required: PropTypes.bool,
	theme: PropTypes.string,
	context: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	childClass: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string,

	wizard: PropTypes.object,
	wizardValuesKey: PropTypes.string,
	config: PropTypes.object,
	configKey: PropTypes.string,
	reactComponentName: PropTypes.string,
	reactComponentCategory: PropTypes.string,
	selectClassName: PropTypes.string,
	optionsClassName: PropTypes.string,
	selectNameAttribute: PropTypes.string,
	componentCategory: PropTypes.string,
	thisArg: PropTypes.object
};

module.exports = SimpleDropdownFromWizard;
